export function dateFormatDisplayMonthAndYear(date: Date): string {
  const month = Intl.DateTimeFormat('en-GB', { month: 'short' }).format(date);
  const year = Intl.DateTimeFormat('en-GB', { year: '2-digit' }).format(date);
  return `${month} '${year}`;
}
